import httpClient from '@/api/httpClient'

export default {
  async getInsertionOrderReport(advertiserId, params) {
    const result = await httpClient.post(
      `/ad_report/${advertiserId}/insertion_order`,
      params,
    )
    return result.data
  },
  async getCampaignReport(advertiserId, params) {
    const result = await httpClient.post(
      `/ad_report/${advertiserId}/campaign`,
      params,
    )
    return result.data
  },
  async getDeliverGroupReport(advertiserId, params) {
    const result = await httpClient.post(
      `/ad_report/${advertiserId}/delivery_group`,
      params,
    )
    return result.data
  },
}
